import type { CalendarVisit } from "@/components/field-calendar/fieldCalendarTypes";

export type DashboardScheduleLegendKey =
  | "scheduled"
  | "in_progress"
  | "completed"
  | "leave"
  | "cancelled";

export const DASHBOARD_SCHEDULE_LEGEND: {
  key: DashboardScheduleLegendKey;
  label: string;
  dotClass: string;
}[] = [
  { key: "scheduled", label: "Scheduled Visit", dotClass: "bg-violet-500" },
  { key: "in_progress", label: "In Progress", dotClass: "bg-emerald-500" },
  { key: "completed", label: "Completed", dotClass: "bg-blue-500" },
  { key: "leave", label: "On Leave", dotClass: "bg-slate-400" },
  { key: "cancelled", label: "Cancelled", dotClass: "bg-red-500" },
];

function isVisitCancelled(v: CalendarVisit): boolean {
  const s = (v.status ?? "").toLowerCase();
  return s === "cancelled" || s === "canceled";
}

export function dashboardScheduleStatusKey(v: CalendarVisit): DashboardScheduleLegendKey {
  if (isVisitCancelled(v)) return "cancelled";
  if (v.status === "closed" || v.status === "waived") return "completed";
  if (v.arrivedAt) return "in_progress";
  return "scheduled";
}

export function dashboardScheduleBarClass(v: CalendarVisit): string {
  const key = dashboardScheduleStatusKey(v);
  if (key === "cancelled") {
    return [
      "border border-red-300 bg-red-50 text-red-900",
      "bg-[repeating-linear-gradient(-45deg,rgba(239,68,68,0.08)_0px,rgba(239,68,68,0.08)_6px,transparent_6px,transparent_12px)]",
    ].join(" ");
  }
  if (key === "completed") {
    return "border-l-4 border-l-blue-500 bg-blue-100 text-blue-950";
  }
  if (key === "in_progress") {
    return "border-l-4 border-l-emerald-600 bg-emerald-100 text-emerald-950";
  }
  return "border-l-4 border-l-violet-600 bg-violet-100 text-violet-950";
}
